import React from 'react';
import {Scrollbar} from '@priority-software/priority-style-react';
import styles from '../styles/list.module.scss';
import {DraggableList} from '../../../components/commonOldtoNew';
import {isRTL} from '../../../Localization';
import {ListProps} from '../types';
import {Item} from './Item';
import {DraggableItem} from './DraggableItem';
import {getFieldMenuData} from '../utils/submenu';
import {isFieldMandatory} from '../utils/crossAPI';
import {priority} from '@priority-software/priority-proto-api/lib';

export const List = (props: ListProps) => {
    return (
        <Scrollbar componentClasses={styles.scrollbar} rtl={isRTL()}>
            <DraggableList
                componentClasses={styles.list}
                data={props.data}
                handleDNDFinish={props.updateData}
                renderItem={({item, index, ...dragProps}) => (
                    <DraggableItem {...dragProps} key={item?.Name}>
                        <ListItem item={item} {...props} {...dragProps} />
                    </DraggableItem>
                )}
            />
        </Scrollbar>
    );
};

const ListItem = props => {
    const {
        item,
        foundItemName,
        viewItemName,
        setSelectedItems,
        selectedItems,
        onUpdate,
        data,
        packages
    } = props;

    const isMandatory = () => {
        if (item instanceof priority.netitems.form.TableViewColumnsDesign) {
            return isFieldMandatory(item.Name);
        }
        return false;
    };

    return (
        <Item
            item={item}
            pack={packages.find(p => p.PackageId === item.PackageId)}
            isFound={foundItemName === item.Name}
            isViewItem={viewItemName.includes(item.Name)}
            setSelectedItems={setSelectedItems}
            selectedItems={selectedItems}
            menuData={getFieldMenuData(
                item,
                data,
                isMandatory(),
                packages.find(p => p.PackageId === item.PackageId)
            )}
            onUpdate={onUpdate}
            isMandatory={isMandatory()}
            {...props}
        />
    );
};
